<template>
  <administrator-layout
    :request-count="newRequestCount"
    :project-count="newProjectCount"
    :showcase-count="newShowcaseCount"
    @scroll-bottom="handleScrollBottom"
  >
    <administrator-portfolios
      v-if="route.name === 'administrator-portfolios'"
      :scroll-bottom="scrollBottom"
    />
    <administrator-portfolio-layout
      v-if="
        route.name === 'administrator-portfolio-details' ||
        route.name === 'administrator-portfolio-projects' ||
        route.name === 'administrator-portfolio-indexes' ||
        route.name === 'administrator-portfolio-scopes' ||
        route.name === 'administrator-portfolio-competencies' ||
        route.name === 'administrator-portfolio-qualities'
      "
      :scroll-bottom="scrollBottom"
    />
    <administrator-requests
      v-if="route.name === 'administrator-requests'"
      :scroll-bottom="scrollBottom"
    />
    <administrator-request-form
      v-if="route.name === 'administrator-requests-form'"
      @update="handleUpdate"
    />
    <administrator-projects
      v-if="route.name === 'administrator-projects'"
      :scroll-bottom="scrollBottom"
    />
    <administrator-project-form
      v-if="route.name === 'administrator-project-form'"
      @update="handleUpdate"
    />
    <administrator-project-management
      v-if="route.name === 'administrator-project-management'"
    />
    <administrator-project-team
      v-if="route.name === 'administrator-project-team'"
    />
    <administrator-project-showcase
      v-if="route.name === 'administrator-project-showcase'"
      @update="handleUpdate"
    />
    <administrator-project-indexes
      v-if="route.name === 'administrator-project-indexes'"
    />
    <administrator-project-report
      v-if="route.name === 'administrator-project-report'"
      @update="handleUpdate"
    />
    <administrator-project-agreement
      v-if="route.name === 'administrator-project-agreement'"
      @update="handleUpdate"
    />
    <administrator-showcases
      v-if="route.name === 'administrator-showcases'"
      :scroll-bottom="scrollBottom"
    />
  </administrator-layout>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import AdministratorLayout from '@/layouts/AdministratorLayout.vue';
  import AdministratorProjects from '@/views/administrator/projects/AdministratorProjects.vue';
  import AdministratorRequests from '@/views/administrator/requests/AdministratorRequests.vue';
  import AdministratorProjectForm from '@/views/administrator/projects/form/AdministratorProjectForm.vue';
  import AdministratorRequestForm from '@/views/administrator/requests/components/AdministratorRequestForm.vue';
  import AdministratorProjectManagement from '@/views/administrator/projects/management/AdministratorProjectManagement.vue';
  import AdministratorProjectReport from '@/views/administrator/projects/report/AdministratorProjectReport.vue';
  import AdministratorProjectTeam from '@/views/administrator/projects/team/AdministratorProjectTeam.vue';
  import AdministratorProjectAgreement from '@/views/administrator/projects/agreement/AdministratorProjectAgreement.vue';
  import AdministratorPortfolios from '@/views/administrator/portfolios/AdministratorPortfolios.vue';
  import AdministratorPortfolioLayout from '@/views/administrator/portfolios/AdministratorPortfolioLayout.vue';
  import AdministratorProjectIndexes from '@/views/administrator/projects/indexes/AdministratorProjectIndexes.vue';
  import AdministratorProjectShowcase from '@/views/administrator/projects/showcase/AdministratorProjectShowcase.vue';
  import AdministratorShowcases from '@/views/administrator/showcases/AdministratorShowcases.vue';
  import { USER_ROLE_ADMINISTRATOR } from '@/api/models/UserRole';

  const api = useApi();
  const route = useRoute();
  const newRequestCount = ref(0);
  const newProjectCount = ref(0);
  const newShowcaseCount = ref(0);
  const scrollBottom = ref(0);

  onMounted(async () => {
    await getNewRequestCount();
    await getNewItemsCount();
  });

  const getNewRequestCount = async () => {
    try {
      const response = await api.request.count(USER_ROLE_ADMINISTRATOR);
      newRequestCount.value = response.count;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getNewItemsCount = async () => {
    try {
      const response = await api.administratorPage.newItemsCount();
      newProjectCount.value = response.projectCount;
      newShowcaseCount.value = response.showcaseCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const handleUpdate = async () => {
    await getNewRequestCount();
    await getNewItemsCount();
  };

  const handleScrollBottom = (value) => {
    scrollBottom.value = value;
  };
</script>

<style scoped lang="scss"></style>
